<template>
  <div>
    <div class="d-flex mx-auto table-title">
      {{ tableName }}
    </div>
    <div class="card card-custom gutter-b">
      <!--begin::Body-->
      <div class="card-body d-flex flex-column p-0">
        <div
          class="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded"
        >
          <v-dialog v-model="downloadOrderDialog" width="300px">
            <DownloadDialog @close="downloadDialogClosed"></DownloadDialog>
          </v-dialog>
          <v-data-table
            :height="tableHeight"
            :headers="translatedColumns"
            fixed-header
            :items="getItems"
            item-key="country_id"
            :server-items-length="pagesAmount * rowsAmount"
            hide-default-footer
            :options.sync="options"
            :page.sync="page"
            :loading="loading"
            class="text-no-wrap"
          >
            <template v-slot:top="">
              <v-item-group class="datatable-custom-header">
                <v-container fluid>
                  <div class="d-flex flex-row">
                    <div class="d-flex mx-3 align-center">
                      <v-select
                        v-model="options.itemsPerPage"
                        :items="rows"
                        append-icon="mdi-chevron-down"
                        @change="getTableData()"
                      />
                    </div>
                    <div class="d-flex mx-3 mr-auto">
                      <Pagination
                        v-if="table"
                        :page="options.page"
                        :pages-amount="pagesAmount"
                        v-on:pagechange="options.page = $event"
                      />
                    </div>
                    <div class="d-flex mx-3 align-center">
                      <v-btn
                        v-if="table"
                        @click="getDownloadUrl()"
                        target="_blank"
                        class="px-8 py-6 datatable-header-btn"
                        elevation="0"
                      >
                        {{ $t("export") }}
                      </v-btn>
                    </div>
                    <div class="d-flex mx-3 align-center">
                      <v-select
                        v-model="selectedColumns"
                        :items="dropdownColumns"
                        multiple
                        item-text="text"
                        item-value="value"
                        append-icon="mdi-view-headline"
                        @change="getTableData()"
                      >
                        <template #selection="{ item, index }">
                          <span v-if="index === 0">Customize view</span>
                        </template>
                        <template #prepend-item>
                          <v-list-item ripple @click="selectAllColumns">
                            <v-list-item-action>
                              <v-icon
                                :color="
                                  selectedColumns.length === 0 ? 'primary' : ''
                                "
                              >
                                {{ icon }}
                              </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Select All</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </v-container>
              </v-item-group>
            </template>
            <template v-slot:item.source="{ item, index }">
              <span class="text-dark-75 d-block font-size-lg">
                {{ item.source }}
              </span>
            </template>
            <template v-slot:item.clicks="{ item, index }">
              <span class="text-dark-75 d-block font-size-lg">
                {{ item.clicks }}
              </span>
            </template>
            <template v-slot:item.violations="{ item }">
              <div v-if="item.violations.length >= 1" class="table_button">
                <v-menu>
                  <template v-slot:activator="{ on: menu, attrs }">
                    <div v-bind="attrs" v-on="{ ...menu }">
                      {{ getFirstSuspicion(item) }}
                      <span v-if="item.violations.length > 1">
                        {{ item.violations.length }}
                      </span>
                    </div>
                  </template>
                  <v-list v-if="item.violations.length > 1">
                    <v-list-item
                      v-for="(violation, index) in item.violations"
                      :key="index"
                    >
                      <v-list-item-title>{{
                        violation.title
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div v-else>
                &ndash;
              </div>
            </template>
            <template v-slot:item.country="{ item }">
              {{ item.country }}
            </template>
          </v-data-table>
        </div>
      </div>
      <!--end::Body-->
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/_Tables/Pagination";
import exportTable from "@/core/mixins/exportTable.mixin";

export default {
  name: "CountriesTable",
  components: { Pagination },
  mixins: [exportTable],
  props: {
    dates: {
      type: Array,
      required: true
    },
    selectedDomains: {
      type: Array,
      required: true
    },
    status: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      tableName: null,
      disabledSwitchers: [],
      loadingSwitchers: [],
      clicksIds: [],
      gclidDialog: false,
      detailsDialog: false,
      row: {},
      loading: false,
      searchQuery: "",
      searchColumn: null,
      rowsAmount: 10,
      sortColumn: null,
      sortDirection: null,
      downloadRequisites: {},
      page: 1,
      pagesAmount: 1,
      searchColumns: [],
      selectedColumns: [],
      availableColumns: [],
      translationColumns: [],
      sortableColumns: [],
      table: null,
      rows: [10, 25, 50, 100],
      timestamp: 0,
      options: {}
    };
  },
  computed: {
    tableHeight() {
      if (this.table && this.table.length > 10) return "550";
      return "auto";
    },
    icon() {
      if (!this.table) return "";
      if (this.availableColumns.length === this.selectedColumns.length)
        return "mdi-checkbox-marked";
      if (this.availableColumns.length !== this.selectedColumns.length)
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    dropdownColumns() {
      let columns = [];
      this.availableColumns.forEach(key => {
        columns.push({
          text: this.translationColumns[key],
          value: key
        });
      });
      return columns;
    },
    translatedColumns() {
      let columns = [];
      this.selectedColumns.forEach(key => {
        columns.push({
          text: this.translationColumns[key],
          value: key,
          sortable: this.sortableColumns.includes(key)
        });
      });
      return columns;
    },
    getItems() {
      return this.table || [];
    }
  },
  watch: {
    options: {
      async handler() {
        await this.getTableData();
      }
    },
    async dates() {
      await this.getTableData();
    },
    async selectedDomains() {
      await this.getTableData();
    },
    async status() {
      await this.getTableData();
    }
  },
  methods: {
    disabledSwitcher(item) {
      return this.disabledSwitchers.find(switcher => item.id === switcher);
    },
    loadingSwitcher(item) {
      return this.loadingSwitchers.find(switcher => item.id === switcher)
        ? "warning"
        : null;
    },
    async showGlids(item) {
      this.row = item;
      this.gclidDialog = true;
      try {
        const { clicks } = await this.$api.analyticsBlocking.getClicksIDs({
          detectId: item.id,
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domains: this.selectedDomains.map(el => el.id)
        });
        this.clicksIds = clicks;
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      }
    },
    async getTableData() {
      this.loading = true;
      if (!this.page) {
        this.page = 1;
      }
      try {
        const {
          downloadRequisites,
          pagesAmount,
          searchColumns,
          visibleColumns,
          availableColumns,
          translations,
          sortableColumns,
          table,
          timestamp,
          name
        } = await this.$api.analyticsCountries.getCountriesTable({
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domains: this.selectedDomains.map(el => el.id),
          searchQuery: this.searchQuery,
          rowsAmount: this.options.itemsPerPage,
          searchColumn: this.searchColumn,
          selectedColumns: this.selectedColumns,
          page: this.options.page,
          sortColumn: this.options.sortBy[0],
          sortDirection:
            this.options.sortDesc[0] === false
              ? "asc"
              : this.options.sortDesc[0] === true
              ? "desc"
              : null,
          tableName: "countriesFraudBlocking",
          banned: this.status * 1
        });
        if (timestamp > this.timestamp) {
          this.downloadRequisites = downloadRequisites;
          this.pagesAmount = pagesAmount;
          this.searchColumns = searchColumns;
          this.selectedColumns = visibleColumns;
          this.availableColumns = availableColumns;
          this.translationColumns = translations;
          this.sortableColumns = sortableColumns;
          this.table = table;
          this.timestamp = timestamp;
          this.tableName = name;
        }
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async selectAllColumns() {
      if (this.selectedColumns.length === this.availableColumns.length) {
        this.selectedColumns = [];
      } else {
        this.selectedColumns = this.availableColumns;
      }
      await this.getTableData();
    },
    async setSorting(columnName) {
      if (columnName !== this.sortColumn) {
        this.sortColumn = columnName;
        this.sortDirection = null;
      }
      if (this.sortDirection) {
        if (this.sortDirection === "desc") {
          this.sortDirection = "asc";
        } else {
          this.sortColumn = null;
          this.sortDirection = null;
        }
      } else {
        this.sortDirection = "desc";
      }
      await this.getTableData();
    },
    getFirstSuspicion(item) {
      return item.violations.find(el => !!el).title;
    }
  }
};
</script>

<style>
.v-progress-linear__background {
  background: #1867c0 !important;
}
.v-progress-linear__indeterminate {
  background: #1867c0 !important;
}
.table-title {
  color: #131212;
  font-size: 1.55rem;
  line-height: 3rem;
  text-align: center;
  margin-bottom: 0.5em;
}
.theme--light.v-select .v-select__selections {
  color: white !important;
}
</style>
